import React from 'react'
import PropTypes from "prop-types"
import { isMobile } from "react-device-detect"
import throttle from "lodash/throttle"
import ReactGA from "react-ga"

import withStyles from "@material-ui/core/styles/withStyles"
import Hidden from "@material-ui/core/Hidden"
import Button from "@material-ui/core/Button"

import Navbar from "../lib/components/Navbar"
import SwipeableCards from "../lib/components/SwipeableCards"
import IndicatorDots from "../lib/components/IndicatorDots"
import BottomControls from "../lib/components/BottomControls"
import OptimizedImage from "../lib/components/OptimizedImage"

import styles from "./styles"
import images from "../constants/images"

const cards = images.map(image => ({
    src: `../images/${image}`,
}))

class App extends React.Component {
    state = {
        currentImageIndex: 0,
    }

    componentDidMount() {
        window.addEventListener("keydown", throttle(this.onKeyDown, 1000))
        
        window.addEventListener("beforeunload", (e) => {
            ReactGA.pageview("exit")

            (e || window.event).returnValue = null;
            return null
        });
    }

    onKeyDown = (event) => {
        const { currentImageIndex } = this.state

        if (event.key === "ArrowLeft" && currentImageIndex > 0) {
            this.onChange(currentImageIndex - 1)
        }

        if (event.key === "ArrowRight" && currentImageIndex < images.length - 1) {
            this.onChange(currentImageIndex + 1)
        }
    }

    onChange = nextIndex => {
        let currentImageIndex = nextIndex

        if (nextIndex < 0) currentImageIndex = images.length - 1
        if (nextIndex > images.length - 1) currentImageIndex = 0

        this.setState({ currentImageIndex })
    }

    render() {
        const { classes } = this.props
        const { currentImageIndex } = this.state
        
        return (
            <div className={classes.root}>
                <Navbar
                    transparent
                    backLink="/"
                    leftIcon={<span className={classes.logo} />}
                    rightElement={<Button href="mailto:marco@marcomeazza.com">Contact</Button>}
                />
                <SwipeableCards
                    cards={cards}
                    minScale={1}
                    initialIndex={currentImageIndex}
                    render={(image) => <OptimizedImage src={image.src} />}
                    classes={{
                        container: classes.swipeableCardsContainer,
                        card: classes.imageContainer,
                    }}
                    onChange={this.onChange}
                />

                <IndicatorDots total={images.length} index={currentImageIndex} />
                <Hidden smDown={isMobile}>
                    <BottomControls
                        onLeftClick={() => this.onChange(currentImageIndex - 1)}
                        onRightClick={() => this.onChange(currentImageIndex + 1)}
                    />
                </Hidden>
            </div>
        );
    }
}

App.propTypes = {
    history: PropTypes.object.isRequired,
    match: PropTypes.object.isRequired,
}

export default withStyles(styles)(App);



// WEBPACK FOOTER //
// ./src/App/index.js